
import Vue from 'vue';

import { Data as ArticleData } from '@root/modules/article/types/article';
import getArticleUrl from '@root/modules/article/utils/buildArticleUrl';
import getArticleMultipageBody from '@root/modules/article/utils/getArticleMultipageBody';

interface Props {
  article: ArticleData;
}

interface Computed {
  articleMultipageBody: Array<Record<string, any>>;
  page: number;
  chunk: Record<string, any>;
  navigation: Record<string, any>;
}

interface Methods {
  handleNavigation: (url: string) => void;
}

interface Navigation {
  prev?: string | null;
  next?: string | null;
}

export default Vue.extend<unknown, Methods, Computed, Props>({
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  computed: {
    articleMultipageBody() {
      return getArticleMultipageBody(this.article, this.$channelConfig('page').article.component);
    },
    chunk() {
      const index = this.page - 1;
      if (this.articleMultipageBody[index]) {
        return this.articleMultipageBody[index];
      }

      return this.articleMultipageBody[0];
    },
    navigation() {
      const navigation: Navigation = {
        prev: null,
        next: null,
      };

      const articleUrl = getArticleUrl({
        article: this.$props.article,
        domain: this.$props.article?.primaryCategory.channel.url,
        fakeDomainEnabled: this.$config.FAKE_DOMAIN_ENABLED,
      });

      if (this.page - 1 > 0) {
        if (this.$route.query.preview) {
          navigation.prev = `${articleUrl}?preview=${this.$route.query.preview}&page=${this.page - 1}`;
        } else {
          navigation.prev = `${articleUrl}?page=${this.page - 1}`;
        }
      }

      if (this.page + 1 <= this.articleMultipageBody.length) {
        if (this.$route.query.preview) {
          navigation.next = `${articleUrl}?preview=${this.$route.query.preview}&page=${this.page + 1}`;
        } else {
          navigation.next = `${articleUrl}?page=${this.page + 1}`;
        }
      }

      return navigation;
    },
    page() {
      let page = 1;

      if (this.$route.query.page !== undefined) {
        page = parseInt(this.$route.query.page as string);
      }

      return page;
    },
  },
  methods: {
    handleNavigation(url: string) {
      this.$store.commit('article/setActiveArticlePath', url);
      this.$router.push(url);
      const navigationPosition = window.scrollY + window.document.getElementsByClassName('article-multipage-navigation')[0].getBoundingClientRect().top;
      window.scrollTo(0, navigationPosition);
    },
  },
});
